<template>
	<StrapiTable v-bind="table">
		<CampaignsTableRow
			v-for="i in items"
			:key="i.id"
			v-bind="i"
			:updating="updating === i.id"
			@activate="onActivate"
			@archive="onArchive"
		/>
	</StrapiTable>
</template>

<script>
import api from '@/mixins/api'
import toast from '@/mixins/toast'
import StrapiTable from '@/components/admin/StrapiTable'
import CampaignsTableRow from '@/components/admin/CampaignsTableRow'
import table from '@/mixins/table'

const tableMixin = table([
	{ column: 'type', label: 'Type' },
	{ column: 'name', label: 'Name' },
	{ column: 'created_at', label: 'Created', sort: 'DESC' },
	{ label: 'Actions' }
])

export default {
	name: 'campaigns-table',
	data() {
		return {
			updating: null
		}
	},
	methods: {
		async onActivate({ id, name, active }) {
			// Find currently active campaign
			const current = this.items.find(i => i.active)

			// Mark submission being updated
			this.updating = id
			const verb = active ? 'activate' : 'deactivate'
			const action = active ? 'put' : 'delete'

			try {
				// Patch submission with new status and refresh parent list
				await this[action](`/campaigns/${id}/active`)
				this.refresh()

				// Alert if another campaign was deactivated
				if (current && current.id !== id) {
					this.toastWarn(`Deactivated the *${current.name}* campaign.`)
				}

				// Alert user that update was successful
				this.toast(`Successfully *${verb}d* the *${name}* campaign.`)
			} catch (err) {
				// Warn user that action failed
				this.toastErr(
					`Failed to ${verb} this campaign. Please try again later.`
				)
			}

			// Reset updating status
			this.updating = null
		},
		async onArchive({ id, name, archive }) {
			// Mark submission being updated
			this.updating = id
			const verb = archive ? 'archive' : 'restore'
			const action = archive ? 'put' : 'delete'
			const isActive = this.items.find(i => i.id === id).active

			try {
				// Patch submission with new status and refresh parent list
				await this[action](`/campaigns/${id}/archived`)
				this.refresh()

				// Alert user that update was successful
				if (isActive)
					this.toast(`Successfully *deactivated* the *${name}* campaign.`)
				this.toast(`Successfully *${verb}d* the *${name}* campaign.`)
			} catch (err) {
				// Warn user that action failed
				this.toastErr(
					`Failed to ${verb} this campaign. Please try again later.`
				)
			}

			// Reset updating status
			this.updating = null
		}
	},
	mixins: [api, toast, tableMixin],
	components: {
		StrapiTable,
		CampaignsTableRow
	}
}
</script>
